export default "__VITE_ASSET__r2NDqpln__"